'use client';
import { useAppSettings } from '@bells/core';
import { cn } from '@bells/core/lib/utils';
import dynamic from 'next/dynamic';
import React from 'react';
import VideoMetaData from '../../../components/video-metadata';
import { LocationSearchPlaceholder } from '../../../editor/components/location-search/location-search-placeholder';
import { Logo } from '../../../icons/logo';
import type { HeroTitleType } from './hero-title.types';
const LocationSearch = dynamic(
  () => import('../../../components/location-search'), // Adjust the import path as necessary
  {
    ssr: false,
    loading: () => (
      <LocationSearchPlaceholder
        className='lg:shadow-lg'
        withSubmit={true}
      ></LocationSearchPlaceholder>
    ),
  }
);
const HeroContent = React.forwardRef<
  HTMLDivElement,
  HeroTitleType & {
    className?: string;
    hasVideo?: boolean;
  }
>(({ title, description, className, hasVideo = true }, ref) => {
  const { frontendUrl } = useAppSettings();
  return (
    <div ref={ref} className='w-full'>
      <VideoMetaData
        title={title}
        description={description}
        thumbnailUrl={`${frontendUrl}/bb-escort-trailer-poster.webp`}
        contentUrl={`${frontendUrl}/bb-escort-trailer.mp4`}
      ></VideoMetaData>

      <div
        className={cn(
          'relative mt-[-58px] w-full bg-[#09090b] dark:bg-[#161616]',
          className
        )}
      >
        {hasVideo && (
          <video
            playsInline
            preload='none'
            controls={undefined}
            height='100%'
            poster='/bb-escort-trailer-poster.webp'
            loop
            muted
            autoPlay
            width='100%'
            className='hide-video-controls pointer-events-none absolute left-0 top-0 z-[-0] h-full w-full select-none object-cover'
          >
            <source src='/bb-escort-trailer.webm' type='video/webm' />
            <source src='/bb-escort-trailer.mp4' type='video/mp4' />
          </video>
        )}

        <div className='absolute left-0 top-0 h-full w-full bg-[#09090b7a] dark:bg-[#09090b7a]'></div>
        <div className='relative z-[1] mx-auto flex h-full w-full max-w-screen-xl flex-col items-center px-4 lg:px-8'>
          <div className='flex max-w-[650px] flex-col items-center gap-8 py-28 pb-10 lg:py-60'>
            <Logo className='text-brand hidden size-12 lg:inline-block lg:size-14'></Logo>
            <div className='flex w-full flex-col gap-3'>
              <h1 className='word-break scroll-m-20 pb-2 text-center font-serif text-4xl font-bold not-italic tracking-wide text-background first:mt-0 dark:text-foreground lg:text-6xl'>
                {title}
              </h1>
              <span className='word-break text-center font-sans text-lg tracking-tight text-[#c9c9c9] lg:text-xl'>
                {description}
              </span>
            </div>
          </div>
          <div className='w-full pb-12 lg:mb-[-52px] lg:pb-0'>
            <LocationSearch withSubmit={true}></LocationSearch>
          </div>
        </div>
      </div>
      <div className='w-full lg:h-[52px]'></div>
    </div>
  );
});
HeroContent.displayName = 'HeroContent';
export { HeroContent };
